<template>
<el-descriptions title="html5 经典知识" :column="1" :border="true">
    <el-descriptions-item label="audio">播放音频的标签</el-descriptions-item>
    <el-descriptions-item label="canvas">用来 draw graphics 绘制图形的</el-descriptions-item>
    <el-descriptions-item label="getCurrentPosition()方法">用来获取一个用户的当前位置</el-descriptions-item>
    <el-descriptions-item label="hrml5中使用Web Storage 存储服务端数据"></el-descriptions-item>
    <el-descriptions-item label="meter">用来表示一个已知范围上的比例度量</el-descriptions-item>
</el-descriptions>
  </template>
<script>
export default {
  name: 'Blogs',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/BlogDetails/index.vue